
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReferenceEventLog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReferenceEventLog"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eventBy"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Researcher"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReferenceEventPayload"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":222}};
    doc.loc.source = {"body":"#import \"./Researcher.gql\"\n#import \"./ReferenceEventPayload.gql\"\n\nfragment ReferenceEventLog on ReferenceEventLog {\n  id\n  event\n  eventBy {\n    ...Researcher\n  }\n  payload {\n    ...ReferenceEventPayload\n  }\n  createdAt\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./Researcher.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ReferenceEventPayload.gql").definitions));


      module.exports = doc;
    
